import { AjaxHelper } from '../../http/ajax_helper';

export abstract class CommonAlbumsManager {
    
    constructor() {        
    }
   /**
   * Method to get the shared token by album id.   
   * @param {string} payload
   * @returns {Promise<any>}
   * @memberof CommonAlbumsModule
   */
    getShareTokenForAlbum(apiBaseUrl: string, payload: string): Promise<any> {

        const url = "social/public";  
        let config = {
            url: apiBaseUrl + url,
            type: "POST",
            async: false,
            data: payload,
        }

        let promise = AjaxHelper.triggerApi({ requestConfig: config });
        return promise;
    }
    /**
     * Method to create a new album with the added assets.   
     * @param {string} payload
     * @returns {Promise<any>}
     * @memberof CommonAlbumsModule
     */
    createAlbum(apiBaseUrl: string, payload: string): Promise<any> {
        const url = "collection";
        let config = {
            url: apiBaseUrl + url,
            type: "PUT",
            data: payload,
        }
        let promise = AjaxHelper.triggerApi({ requestConfig: config });
        return promise;
    }
}